import { useContext } from "react"
import { config } from "../context/config"
import '../style/pages/settings.css'
import Configuration from "../components/settings/config";
import System from "../components/settings/systemConfig";
import Society from "../components/settings/invoices";
import Rules from "../components/settings/rules";
import ClearCacheButton from "../components/settings/ClearCacheButton";
import Logout from "../components/settings/logout";
import { collection } from "../context/collect";

export default function Settings () {
    const {stylingNav} = useContext(config);
    const { cconfig, setCconfig } = useContext(collection);
    return (
        <div className={`settings page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <div className="head flex">
                <h1>settings</h1>
                {/* for paymob only :() */}
                {/* <select value={cconfig.workMode} onChange={(e) => setCconfig((prev) => ({
                    ...prev,
                    workMode: e.target.value
                }))}>
                    <option disabled autoFocus>select work mode</option>
                    <option value={'test'} className="warning">Test mode</option>
                    <option value={'live'} className="success">Live mode</option>
                </select> */}
            </div>
            <System />
            <Configuration />
            <Society/>
            <Rules />
            <div className="flex flex-align-item-center">
                <ClearCacheButton/>
                <Logout />
            </div>
        </div>
    )
}